export default __webpack_public_path__ + "static/media/danger_animated.aca30c0b.svg";